import R from "ramda";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { useOfferGroupsActions } from "store/OfferGroupsSlice";

const useOfferGroups = () => {
  const { loadOfferGroups } = useOfferGroupsActions();

  const offerGroupsSelector = (state) => state.OfferGroupsSlice.offerGroups;
  const offersSelector = createSelector(offerGroupsSelector, (offerGroup) => R.propOr([], "offers", offerGroup));
  const firstOfferSelector = createSelector(offerGroupsSelector, offersSelector, (offerGroup, offers) =>
    R.head(offers),
  );

  const defaultOfferSelector = createSelector(offerGroupsSelector, firstOfferSelector, (offerGroup, firstOffer) => {
    return !R.isNil(firstOffer)
      ? firstOffer
      : {
          displayName: "No Active Offers",
          description: `No active offers in offer group "${offerGroup.name}"`,
          image: "",
        };
  });

  return {
    defaultOffer: useSelector(defaultOfferSelector),
    loadOfferGroups,
  };
};

export default useOfferGroups;
